export default "__VITE_ASSET__c15146fe__"